import {useMutation} from "@tanstack/react-query";

import {errorHandler} from "@/src/modules/core/lib";
import {captureParkingSubmitError} from "@/src/modules/core/lib/glitchtip/parking-capture";

import {shiftsService} from "../services";

export default function useCreateEmergencyShift() {
  return useMutation({
    mutationFn: shiftsService.createEmergencyShift,
    onError: (error) => {
      captureParkingSubmitError(error, {feature: "shifts", operation: "emergency_shift_start"});
      errorHandler(error);
    },
  });
}
